if($('.form-options-intro').length) {

    let select = $('#contact-form-options-select');

    setTimeout(function () {
        $(".form-option").not('.form-option-' + select.val()).hide();
    }, 1500);

    select.on('change', function () {
        let newIndex = $(this).val();

        $(".form-option").not('.form-option-' + newIndex).hide();
        $(".form-option-" + newIndex).show();
    });

}


if($('.form-options-container').length) {

    let select = $('#embed_form_chooser');

    setTimeout(function () {
        $(".form-option-item").not('.form-option-item-' + select.val()).removeClass('not-first').hide();
        // $('.not-first').removeClass('.not-first');
    }, 1500);

    select.on('change', function () {
        let newIndex = $(this).val();

        $(".form-option-item").not('.form-option-item-' + newIndex).hide();
        $(".form-option-item-" + newIndex).show();
    });

}
